import React from 'react'
import { Box, Button, Popover, TextField } from '@mui/material'

export type CommentDraft = { rowKey: string; itemId: string; anchorEl: HTMLElement; text: string }

type Props = {
  draft: CommentDraft | null
  onChange: (next: CommentDraft | null) => void
  onSubmit: (draft: CommentDraft) => void
}

const CommentPopover = ({ draft, onChange, onSubmit }: Props) => (
  <Popover
    anchorEl={draft?.anchorEl}
    open={!!draft}
    onClose={() => onChange(null)}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    <Box sx={{ p: 1.5, width: 260 }}>
      <TextField
        autoFocus
        multiline
        minRows={2}
        fullWidth
        placeholder="Add a comment"
        value={draft?.text ?? ''}
        onChange={(event) => onChange(draft ? { ...draft, text: event.target.value } : null)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
        <Button size="small" onClick={() => onChange(null)}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            if (draft) {
              onSubmit(draft)
            }
            onChange(null)
          }}
        >
          Send
        </Button>
      </Box>
    </Box>
  </Popover>
)

export default CommentPopover
